<template>
    <div class="whitespace-pre-wrap pb-2">
        <div class="flex justify-between">
            <!-- <div class="flex justify-start items-center space-x-1 tracking-wide font-semibold text-gray-800">
                <div class="">{{ actionResolvedDate }}</div>
                <div class="truncate"> {{ actionUser }}</div>
            </div>  
            <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-1.5 mx-1"></div>     -->
            <div v-if="actionDetails==''"  class="font-semibold text-gray-800" ><span :class="actionDateClass">{{ actionDate }}</span>: {{ actionName }}</div>
            <div v-else class="flex justify-end items-center">
                <div class="font-semibold"><span :class="actionDateClass">{{ actionDate }}</span>: <span class="cursor-pointer hover:underline hover:text-dark-secondary text-indigo-500" @click="showActionDetails">{{ actionName }}</span></div>
                <InfoModal
                    :is-modal-visible="visibleActionDetails"
                    @close="hideActionDetails"
                >
                    <template #header>
                    Event Details
                    </template>
                    <template #body>
                        <div class="w-full whitespace-pre-wrap break-before-auto text-start">
                            {{ actionDetails }}:
                        </div>
                    </template>
                </InfoModal>
            </div>
            <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-1.5 mx-1"></div>    
            <div  v-if="actionUser" class="flex justify-start items-center space-x-1 tracking-wide text-gray-800">
                <div class="truncate">{{ actionUser }}</div>
                <!-- <div class="">on {{ actionResolvedDate }}</div> -->
            </div>  
        </div>
        <div class="flex flex-col items-start">  
            <div class="line-clamp-1">{{ actionNotes}}</div>
        </div>
    </div>
</template>

<script setup>
import { defineProps, ref, computed } from 'vue';
import { formatDate, getTodaysDateAsString } from '@/composables/formatDate';
import InfoModal from "../InfoModal.vue"

const props = defineProps(['crmAction'])

const visibleActionDetails = ref(false)

// A detail with no resolved date is still open, so it's dated by when it's due.
const isOpen = computed(() => {
    return !!props.crmAction && !props.crmAction.resolved_date
})

const isOverdue = computed(() => {
    if(isOpen.value && props.crmAction.due_date) {
        // due_date is a plain date, so it's compared to today as a plain date --
        // a detail due today isn't overdue yet.
        return props.crmAction.due_date < getTodaysDateAsString()
    }
    return false
})

const actionDate = computed(() => {
    if(props.crmAction) {
        if(props.crmAction.resolved_date) {
            return `${formatDate(props.crmAction.resolved_date)}`
        }
        if(isOpen.value) {
            return props.crmAction.due_date ? `Due ${formatDate(props.crmAction.due_date)}` : 'Due'
        }
    }
    return ''
})

const actionDateClass = computed(() => {
    if(isOverdue.value) {
        return 'text-red-600'
    } else if(isOpen.value) {
        return 'text-amber-600'
    }
    return ''
})

const actionUser = computed(() => {
    if(props.crmAction) {
        if(props.crmAction.user){
            return `${props.crmAction.user.first_name} ${props.crmAction.user.last_name}`
        }
    }
    return ''
})

const actionName = computed(() => {
    if(props.crmAction) {
        if(props.crmAction.action){
            if(isOpen.value) {
                return props.crmAction.action.unresolved_label || props.crmAction.action.action_name
            }
            return props.crmAction.action.action_name
        }
    }
    return ''
})

const actionNotes = computed(() => {
    if(props.crmAction) {
        if(props.crmAction.action_notes){
            return props.crmAction.action_notes
        }
    }
    return ''
})

const actionDetails = computed(() => {
    if(props.crmAction) {
        if(props.crmAction.action_details){
            return props.crmAction.action_details
        }
    }
    return ''
})

function showActionDetails() {
    visibleActionDetails.value = true
}

function hideActionDetails() {
    visibleActionDetails.value = false
}

</script>